/**
 * Icons and Images Constants
 * Contains all icon URLs, image URLs, and related alt texts
 */

export enum ICON_URLS {
  DefaultImageUrl = '/assets/images/default_profile.png',
  GenericUserIcon = '/assets/icons/generic-user-icon.svg',
  CloseIcon = '/assets/icons/close-black.svg',
  CloseWhiteIcon = '/assets/icons/close.svg',
  Calendar = '/assets/icons/circle-calendar.svg',
  CalendarDisable = '/assets/icons/circle-calendar-disable.svg',
  Check = '/assets/icons/check.svg',
  Edit = '/assets/icons/icon-button-edit.svg',
  IconSave = '/assets/icons/icon-save.svg',
  IconSaveDisable = '/assets/icons/icon-save-disable.svg',
  Message = '/assets/icons/message-icon.svg',
  DarkLogo = '/assets/images/Logo_by_dark.svg',
  LightLogo = '/assets/images/Logo_By.svg',
  IconApprove = '/assets/icons/check-jade.svg',
  IconReject = '/assets/icons/x-close.svg',
  IconPending = '/assets/icons/FillingClock.svg',
  IconExclaim = '/assets/icons/icon-exclaim.svg',
  IconExclaimPurple = '/assets/icons/icon-exclaim-info.svg',
  Close = '/assets/icons/close-purple.svg',
  IconCloseRed = '/assets/icons/x-close-red.svg',
  Clipboard = '/assets/icons/Clipboard.svg',
  ChevronUp = '/assets/icons/chevron-up-purple-heart.svg',
  ChevronDown = '/assets/icons/chevron-down-purple-heart.svg',
  ChevronBack = '/assets/icons/chevron-back.svg',
  UserCircle = '/assets/images/default_circle_users.svg',
  FINALIZED_ICON = '/assets/icons/check-dark.svg',
  IN_PROGRESS_ICON = '/assets/icons/icon-white-clock.svg',
  NOT_STARTED_ICON = '/assets/icons/icon-clock.svg',
  InformationPurple = '/assets/icons/information-purple.svg',
  CalendarIcon = '/assets/icons/calendar.svg',
  RocketWhite = '/assets/icons/rocket-white.svg',
  ArrowRightWhite = '/assets/icons/arrow-right-white.svg',
  IconWaiting = '/assets/icons/icon-waiting.svg',
  IconSuccess = '/assets/icons/icon-success.svg',
  IconTriangle = '/assets/icons/alert-triangle.svg',
  IconWarning = '/assets/icons/icon-warning.svg',
  IconBarChart = '/assets/icons/icon-bar-chart.svg',
  ImageHeartWhite = '/assets/images/heart-white.png',
  AlertTriangleRoundedPurple = '/assets/icons/alert-triangle-rounded-purple.svg',
  AlertTriangleRed = '/assets/icons/Alert.svg',
  PlusWhite = '/assets/icons/Plus-white.svg',
  GridIcon = '/assets/icons/grid-icon.svg',
  GridCircleIcon = '/assets/icons/grid-circle-icon.svg',
  ListIcon = '/assets/icons/list-icon.svg',
  ListCircleIcon = '/assets/icons/list-circle-icon.svg',
  NotificationIcon = '/assets/icons/Union.svg',
  MoreVerticalIcon = '/assets/icons/More-Vertical.svg',
  ShopIcon = '/assets/icons/shop.svg',
  PercentageIcon = '/assets/icons/purple-percentage.svg',
  AlertPending = '/assets/icons/alert-pending.svg',
  TrashIcon = '/assets/icons/trash-icon.svg',
  IconUsers = '/assets/icons/Users.svg',
  UserRol = '/assets/icons/user-rol.svg',
  AddSmallIcon = '/assets/icons/add-small-icon.svg',
  FlagIcon = '/assets/icons/flag-icon.svg',
  EditWhite = '/assets/icons/edit-white.svg',
  EditPurple = '/assets/icons/edit-purple.svg',
  File = '/assets/icons/file.svg',
  FilePurple = '/assets/icons/file-purple.svg',
  MessagePurple = '/assets/icons/message-purple.svg',
  EliminateIcon = '/assets/icons/Eliminate.svg',
  HistorialIcon = '/assets/icons/Historial.svg',
  LinkIcon = '/assets/icons/link.svg',
}

export enum IMAGES {
  DefaultUserImage = '/assets/images/default_profile.png',
  Close = '/assets/icons/close-purple.svg',
  Clipboard = '/assets/icons/Clipboard.svg',
}

export enum IconNames {
  CheckJade = 'check-jade',
  Close = 'x-close',
  RedClose = 'x-close-red',
  FillingClock = 'FillingClock',
}

export const PROFILE_IMAGE_DEFAULT = '/assets/images/default_circle_user.png';
export const PROFILE_IMAGE_URL = '/images/users_avatar/';
export const PROFILE_IMAGE_URL_POSTFIX = '_REDONDA.png';

export const ALT_CHECK_TEXT = 'Check del seniority';
export const ALT_DARK_LOGO = 'Pragma_Logo_by_dark';
export const ALT_AVATAR = 'Avatar';
export const ALT_LIGHT_LOGO = 'Pragma_Logo_by';
export const ALT_DATE_ICON = 'Calendario';
export const ALT_STATUS_ICON = 'Icono de estado';
export const ALT_CLOSE_ICON = 'Cerrar';
export const ALT_CLIPBOARD_ICON = 'Portapapeles';
export const ALT_OPEN_CLOSE_COMMENT = 'Abrir o cerrar comentario';
export const ALT_PHOTO_ATTACHMENT = 'Foto adjuntada';
export const ALT_PROFILE_PHOTO_ADDITIONAL = 'Manager';
export const ALT_TEXT_EDIT = 'Editar Información de chapter';
